import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Empty-state placeholder for trainer routes that haven't shipped yet.
 * Keeps the sidebar navigation feeling complete without pretending
 * these surfaces exist. Matches the visual language of the library
 * page — brand-tinted eyebrow, serif italic title, quiet subtitle.
 */
interface Props {
  eyebrow?: string;
  title:   string;
  subtitle?: string;
}

const TrainerPlaceholder: React.FC<Props> = ({ eyebrow, title, subtitle }) => (
  <div
    className="min-h-screen bg-[#f6f8fb] px-4 py-10 sm:px-8 lg:px-10"
    style={{ fontFamily: "'Afacad Flux', system-ui, sans-serif" }}
  >
    <div className="mx-auto max-w-4xl">
      {eyebrow && (
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
          {eyebrow}
        </div>
      )}
      <h1
        className="mt-1 text-4xl leading-tight text-slate-900"
        style={{ fontFamily: "'Instrument Serif', serif", fontStyle: 'italic' }}
      >
        {title}
      </h1>
      {subtitle && (
        <p className="mt-2 max-w-xl text-sm text-slate-600">
          {subtitle}
        </p>
      )}

      <div className="mt-8 rounded-2xl border border-dashed border-slate-200 bg-white px-8 py-16 text-center shadow-[0_1px_2px_rgba(0,0,0,0.03)]">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1a5276]/10 to-[#0e9172]/10 text-[#0e9172]">
          <Sparkles className="h-5 w-5" />
        </div>
        <p className="mt-4 text-[13px] font-semibold text-slate-700">Coming soon</p>
        <p className="mx-auto mt-1 max-w-sm text-[12.5px] text-slate-500">
          We're building this surface. For now, everything you need lives in
          the Library.
        </p>
      </div>
    </div>
  </div>
);

export default TrainerPlaceholder;
